import { useContext, useState, useEffect } from "react";

//Components
import PersonDetailWrapper from "./PersonDetail";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AppBar, Tabs, Tab, Typography, Box } from "@material-ui/core";

//Styling
import { useStyles } from "../../Styles/styles";

//Utils
import PropTypes from "prop-types";
import { UserContext } from "../../Contexts/UserContext";
import { personAlertColor } from "../../utils/utils";
import { createEmptyPersonIncidentSpecific } from "../../utils/EmptyObjects";
import { IncidentsContext } from "../../Contexts/IncidentsContext";
import { INCIDENT_ACTIONS } from "../../Actions/IncidentActions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: "0px" }} p={1}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const PeopleDetail = ({
  peopleInfoLoading,
  peopleInfoData,
  peopleInfoError,
  getPissForIncident,
  piss,
  incidentId,
  incidentUuid,
  incidentIndex,
  incidentOriId,
  incidentCallTime,
  handlePersonOpening,
  userRoles,
  setPausePolling,
  setPopper,
  _peopleDetailIsMounted,
  incidentPeople,
  ...props
}) => {
  const classes = useStyles();
  const [personTab, setPersonTab] = useState(0);
  const { onlineState, nightMode, user } = useContext(UserContext);
  const { ADD_PIS } = INCIDENT_ACTIONS;
  const { incidentDispatch } = useContext(IncidentsContext);

  const handleChange = (event, newValue) => {
    setPersonTab(newValue);
  };

  useEffect(() => {
    if (piss.length === 0) {
      if (onlineState) {
        getPissForIncident();
      } else {
        const emptyPis = createEmptyPersonIncidentSpecific(
          null,
          null,
          null,
          user
        );
        incidentDispatch({
          type: ADD_PIS,
          payload: { incidentId: incidentId, pis: emptyPis },
        });
      }
    }
  }, [
    ADD_PIS,
    getPissForIncident,
    incidentDispatch,
    incidentId,
    onlineState,
    piss.length,
    user,
  ]);

  useEffect(() => {
    _peopleDetailIsMounted.current = true;
    return () => {
      // ComponentWillUnmount in Class Component
      _peopleDetailIsMounted.current = false;
    };
  }, [_peopleDetailIsMounted]);

  // if (peopleInfoLoading && onlineState) return <div><CircularProgress data-cy="loading-circle" /></div>
  if (peopleInfoError) return <p>Error: {peopleInfoError}</p>;
  if (
    peopleInfoData ||
    piss ||
    !onlineState ||
    import.meta.env.VITE_FORCE_ONLINE === "true"
  ) {
    return (
      <div className={classes.tabsDiv}>
        <AppBar position="static" color="default">
          <Tabs
            value={personTab}
            onChange={handleChange}
            indicatorColor="primary"
            // textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            {piss.map((pis, index) => {
              let firstInitial = pis.person?.personalAttribute?.firstName
                ? pis.person.personalAttribute.firstName.substring(0, 1)
                : "";
              let lastName = pis.person?.personalAttribute?.lastName || "";
              let type = pis.incidentInvolvement
                ? pis.incidentInvolvement.name
                : "Caller";
              return (
                <Tab
                  style={{
                    color:
                      personAlertColor(pis?.person) || (nightMode && "white"),
                  }}
                  key={pis.id}
                  label={`${type}: ${
                    lastName && lastName + ","
                  } ${firstInitial}`}
                  {...a11yProps(index)}
                />
              );
            })}
          </Tabs>
        </AppBar>
        {piss.map((pis, index) => {
          return (
            <TabPanel key={pis.id} value={personTab} index={index}>
              <PersonDetailWrapper
                setPopper={setPopper}
                key={pis.id}
                pis={pis}
                pisIndex={index}
                incidentId={incidentId}
                incidentUuid={incidentUuid}
                incidentIndex={incidentIndex}
                incidentCallTime={incidentCallTime}
                personTab={personTab}
                setPersonTab={setPersonTab}
                peopleLength={piss.length}
                incidentOriId={incidentOriId}
                inIncident={true}
                incidentPeople={incidentPeople}
                handlePersonOpening={handlePersonOpening}
                userRoles={userRoles}
                setPausePolling={setPausePolling}
                getPissForIncident={getPissForIncident}
                {...props}
              />
            </TabPanel>
          );
        })}
      </div>
    );
  } else {
    return (
      <div>
        <CircularProgress data-cy="loading-circle" />
      </div>
    );
  }
};

export default PeopleDetail;
